/**
 * 判断当前环境
 */
var USER_AGENT_PATTREN = {
    ANDROID: /Android (\d+)/,
    IOS: /(iPhone\sOS)\s([\d_]+)/,
    QQ: /QQ\/\d+\.\d+/,
    QZONE: /Qzone/,
    WE_CHAT: /MicroMessenger/,
    WE_SEE: /weishi/i,
    PITU: /PITU\/[\w-\.]+/
};
export var isPC = function () {
    return !/(iPhone|iPad|iPod|iOS|Android)/i.test(window.navigator.userAgent);
};
export var isAndroid = function () {
    return USER_AGENT_PATTREN.ANDROID.test(navigator.userAgent);
};
export var isIOS = function () {
    return USER_AGENT_PATTREN.IOS.test(navigator.userAgent);
};
export var isQQ = function () {
    return USER_AGENT_PATTREN.QQ.test(navigator.userAgent);
};
export var isQzone = function () {
    return USER_AGENT_PATTREN.QZONE.test(navigator.userAgent);
};
export var isWeChat = function () {
    return USER_AGENT_PATTREN.WE_CHAT.test(navigator.userAgent);
};
export var isWeSee = function () {
    return USER_AGENT_PATTREN.WE_SEE.test(navigator.userAgent);
};
export var isPitu = function () {
    return USER_AGENT_PATTREN.PITU.test(navigator.userAgent);
};
export var isChrome = function () {
    var ua = window.navigator.userAgent;
    return ua.match(/chrome\/([\d.]+)/gi) || ua.match(/CriOS\/([\d.]+)/) ? true : false;
};
export var isWeixinMinProgram = function () {
    return typeof window !== 'undefined' && window.__wxjs_environment === 'miniprogram';
};
export var isMobile = function () {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent);
};
export function isMQQ() {
    return /qq\/(\d+\.\d+)/i.test(window.navigator.userAgent.toLowerCase());
}
/**
 * 比较版本号高低
 * @param version 待比较的版本号
 * @param baseVersion 基准版本号
 */
var compareVersion = function (version, baseVersion) {
    var verList = version.split('.');
    var baseVerList = baseVersion.split('.');
    var maxLength = Math.max(verList.length, baseVerList.length);
    for (var i = 0; i < maxLength; i++) {
        var num = Number(verList[i]) || 0;
        var baseNum = Number(baseVerList[i]) || 0;
        if (num < baseNum) {
            return -1;
        }
        else if (num > baseNum) {
            return 1;
        }
    }
    return 0;
};
export var isNewWeChat = function () {
    var ua = navigator.userAgent;
    var REGEXP_WEIXIN = /\bMicroMessenger\/([\d\.]+)/;
    var m = ua.match(REGEXP_WEIXIN);
    var minVersion = '6.5.6'; //此版本后拉起手Q用新api
    // 企业微信没有封堵 schema...
    var isWxWork = /\bwxwork\/([\d\.]+)/.test(ua);
    if (m && m[0] && m[1]) {
        if (compareVersion(m[1], minVersion) >= 0) {
            return !isWxWork;
        }
        return false;
    }
    return false;
};
var Platform;
(function (Platform) {
    Platform["PC"] = "PC";
    Platform["MQQ"] = "mqq";
    Platform["WeChat"] = "wx";
    Platform["WeChartMiniProgram"] = "wx-miniprogram";
    Platform["Pitu"] = "pitu";
    Platform["Mobile"] = "mobile";
    Platform["Undefine"] = "undefine";
})(Platform || (Platform = {}));
/**
 * 获取当前运营环境platform字符串
 */
export var getPlatform = function () {
    if (isPC())
        return Platform.PC;
    if (isMQQ())
        return Platform.MQQ;
    if (isWeChat())
        return Platform.WeChat;
    if (isWeixinMinProgram())
        return Platform.WeChartMiniProgram;
    if (isPitu())
        return Platform.Pitu;
    if (isMobile())
        return Platform.Mobile;
    return Platform.Undefine;
};
